import { Form } from 'antd'
import FormlessModal from 'components/CIMSModal/FormlessModal'
import { useIssueTrackerContext } from '../IssueTrackerContext'
import { IssueStatus } from '@cims-online/shared'
import { useForm } from 'antd/lib/form/Form'
import { useCreateIssueFormItems } from 'App/components/ProjectRoutes/components/issues/hooks/useCreateIssueFormItems'
import { CreateIssueFormItemsValues } from 'App/components/ProjectRoutes/components/issues/hooks/useCreateIssueFormItems/components/CreateIssueFormItems/types'
import { usePayItemSelectContext } from 'components/CIMSSelect/common/PayItemSelect/PayItemSelectContext'
import { useEffect } from 'react'
import CustomFieldEditor from 'components/CustomFields/CustomFieldEditor'
import { useProjectCustomFieldsContext } from 'components/CustomFields/ProjectCustomFieldsContext'
import { CustomFieldEditorValues } from 'components/CustomFields/CustomFieldEditor/types'
import { useIssueReportsSelectOptionsContext } from '../../../IssueReportsSelectOptionsContext'
import ExternalLinkEditor from 'components/ExternalLinkEditor'

const DraftSubmitModal: React.VFC = () => {
  const {
    issues,
    relations,
    draftSubmitModal: { state, toggle, visible },
    quickLinkOptions,
  } = useIssueTrackerContext()
  const [form] = useForm<CreateIssueFormItemsValues & CustomFieldEditorValues>()
  const number = crypto.randomUUID()
  const { CreateIssueFormItems, ModalFooter, draftSubmit, cleanUp } =
    useCreateIssueFormItems({
      number: state?.number?.toString() ?? number,
      form,
      toggle,
      cleanup: !state,
    })
  const { toLabeledValues: toPayItems } = usePayItemSelectContext()
  const { toLabeledValues: toReports } = useIssueReportsSelectOptionsContext()
  const { toCustomFieldEditorValue } = useProjectCustomFieldsContext()
  useEffect(() => {
    form.setFieldsValue({
      issueTypes: state?.types.map(({ id, name, description }) => ({
        label: name,
        value: id,
        tooltip: description,
      })),
      submit: false,
      description: state?.description,
      externalLinks: state?.externalLinks,
      payItems: toPayItems(state?.payItems),
      reports: toReports(
        state?.reports?.map(
          ({
            asphaltLot,
            concreteTest,
            concreteTestSet,
            dailyInspectionControlPoint,
            dailyInspectionInspection,
            dailyInspectionPunchList,
            lot,
          }) =>
            asphaltLot ??
            concreteTest ??
            concreteTestSet ??
            dailyInspectionControlPoint ??
            dailyInspectionInspection ??
            dailyInspectionPunchList ??
            lot
        )
      ),
      customFields: toCustomFieldEditorValue(state?.customFields),
    })
  }, [form, toCustomFieldEditorValue, state, toPayItems, toReports])
  return (
    <FormlessModal
      title={
        state?.statusId === IssueStatus.Draft.id
          ? `Submit ${state?.formattedNumber}`
          : 'Create Issue'
      }
      ok={false}
      visible={visible}
      cancel={{ fn: () => cleanUp() }}
      footer={ModalFooter}
      afterClose={() => form.resetFields()}
    >
      <Form
        form={form}
        onFinish={async (values) => {
          if (!state) await draftSubmit({ ...values, number })
          else await draftSubmit({ ...values, id: state.id })
          issues.refetch()
          relations.refetch()
          toggle(null)
        }}
      >
        {CreateIssueFormItems}
        <CustomFieldEditor
          alreadyDisabled={false}
          hideBooleans={!state ? undefined : true}
        />
        <ExternalLinkEditor quickLinkOptions={quickLinkOptions} />
      </Form>
    </FormlessModal>
  )
}

export default DraftSubmitModal
